"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostService = void 0;
var request_handler_1 = require("../class/request-handler");
var HostService = /** @class */ (function (_super) {
    __extends(HostService, _super);
    function HostService() {
        var _this = _super.call(this) || this;
        _this.HOST_API = {
            revalidateSinglePage: function (path) {
                return _this.getHostEndpointUrl("api/tpd/contentmanagment/v1/content/revalidateSinglePage?path=".concat(path));
            },
            getSSO: function () {
                return _this.getHostEndpointUrl("api/tpd/contentmanagment/v1/content/getSSO");
            },
        };
        return _this;
    }
    HostService.prototype.revalidateSinglePage = function (path) {
        var url = this.HOST_API.revalidateSinglePage(path);
        function fetchRevalidateSinglePage() {
            return fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });
        }
        return this.handleRequest(fetchRevalidateSinglePage);
    };
    HostService.prototype.getSSO = function (url, token) {
        var _this = this;
        return this.handleRequest(function () {
            return fetch(_this.HOST_API.getSSO(), {
                method: "POST",
                body: JSON.stringify({
                    token: token,
                    url: url,
                }),
            });
        });
    };
    HostService.className = "HostService";
    return HostService;
}(request_handler_1.RequestHandler));
exports.HostService = HostService;
